'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = undefined;

var _Notification2 = require('./Notification');

var _Notification3 = _interopRequireDefault(_Notification2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Notification = _Notification3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/index.js
// module id = 1697
// module chunks = 0